import { Component } from 'react';
import styled from 'styled-components';

const ItemElement = styled.li`
  margin: 0;
  cursor: pointer;
  display: block;
  border: none;
  height: auto;
  text-align: left;
  border-top: none;
  line-height: 1em;
  color: #1a1d1f;
  font-size: 14px;
  text-transform: none;
  font-weight: 400;
  box-shadow: none;
  padding: 0.8rem 1.1rem;
  box-sizing: border-box;
  white-space: normal;
  word-wrap: normal;
  background-color: white;
  text-decoration: none;

  &:hover {
    background-color: ${props => props.theme.vars.newColor.blue4};
  }
`;

export interface IProps {
  onClick?: (e: any) => void;
  closeMenu?: () => void;
}

export class DropdownButtonItem extends Component<IProps> {
  public render() {
    return (
      <ItemElement onClick={this.handleClick} tabIndex={0}>
        {this.props.children}
      </ItemElement>
    );
  }

  private handleClick = e => {
    if (this.props.closeMenu) {
      this.props.closeMenu();
    }
    if (this.props.onClick) {
      this.props.onClick(e);
    }
  };
}
